import { render, staticRenderFns } from "./CarrierDestinationList.vue?vue&type=template&id=59b5dd70&scoped=true&"
import script from "./CarrierDestinationList.vue?vue&type=script&lang=js&"
export * from "./CarrierDestinationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b5dd70",
  null
  
)

export default component.exports